import type { ReactNode } from "react";
import { MarkdownContent } from "@/components/shared/Markdown/MarkdownContent";
import styles from "./GenericErrorPage.module.scss";

interface IGenericErrorPageProps {
  icon?: ReactNode;
  illustration?: ReactNode;
  markdown: string;
  actions?: ReactNode;
}

export function GenericErrorPage({ icon, illustration, markdown, actions }: IGenericErrorPageProps): ReactNode {
  return (
    <div className={styles.container}>
      {illustration ? (
        <div className={styles.splitContent}>
          <div className={styles.illustration} aria-hidden="true">
            {illustration}
          </div>

          <div className={styles.splitText}>
            <div className={styles.markdown}>
              <MarkdownContent content={markdown} />
            </div>

            {actions ? <div className={styles.actionsSplit}>{actions}</div> : null}
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          {icon ? (
            <span className={styles.icon} aria-hidden="true">
              {icon}
            </span>
          ) : null}

          <div className={styles.markdown}>
            <MarkdownContent content={markdown} />
          </div>

          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </div>
      )}
    </div>
  );
}
